import { makeStyles, TableCell, TableRow, Theme } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ClientBillingTier } from "../../Types/ClientBilling";

const useStyles = makeStyles((theme: Theme & { palette: { primary: { blue: string } } }) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
}));

interface BillingTierCellProps {
  columns: TableColumn[];
  element: ClientBillingTier;
  index: number;
}

export default function BillingTierCell({ columns, element, index }: BillingTierCellProps) {
  const classes = useStyles();
  const history = useHistory();

  function changePage() {
    history.push("/billingtiers/billingtiersdetailed", element);
  }

  return (
    <TableRow
      hover
      className={index % 2 ? classes.rowCell : classes.rowCellOdd}
      key={element.id}
      onClick={changePage}
      aria-label="Go to billing tier details page"
    >
      {columns.map((column) => (
        <TableCell align="left" key={column.propName}>
          {element[column.propName]}
        </TableCell>
      ))}
    </TableRow>
  );
}
